<template>
  <div id="accountPassword-edit">
      <IForm ref="formInline" :model="edit" :elem="accountPasswordElem" :rules="accountPasswordRule"
        :label-width="100" @on-submit="toSubmit" :submit="false" :showMessage="true">
        <div slot="extend">
          <Row>
            <Col span="24"><FormItem label="机构名称" prop="name" ><Input v-model="edit.name" type="text" placeholder="请输入机构名称" maxlength="50"/></FormItem></Col>
          </Row>
          <Row>
            <Col span="12"><FormItem label="体检账号" prop="account" ><Input v-model="edit.account" type="text" placeholder="请输入体检账号" maxlength="100"/></FormItem></Col>
            <Col span="12"><FormItem label="体检密码" prop="password" ><Input v-model="edit.password" type="text" placeholder="请输入体检密码" maxlength="100"/></FormItem></Col>
          </Row>
          <Row>
            <Col span="24"><FormItem label="局域网路径" prop="localAreaUrl" ><Input v-model="edit.localAreaUrl" type="text" placeholder="请输入局域网路径" maxlength="512"/></FormItem></Col>
          </Row>
          <Row>
            <Col span="24"><FormItem label="映射路径" prop="url" ><Input v-model="edit.url" type="text" placeholder="请输入映射路径" maxlength="512"/></FormItem></Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem label="启用路径" prop="urlType">
                <RadioGroup prop="type" v-model="edit.urlType">
                  <Radio v-for="item in urlTypeList" v-bind:key="item.value" :label="item.value">{{item.label}}</Radio>
                </RadioGroup>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="打印日志" prop="printLog">
                <RadioGroup prop="type" v-model="edit.printLog">
                  <Radio v-for="item in printLogList" v-bind:key="item.value" :label="item.value">{{item.label}}</Radio>
                </RadioGroup>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem label="状态" prop="status">
                <Select v-model="edit.status">
                  <Option v-for="item in statusList" :value="item.value" v-bind:key="item.value" >{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
        </div>
      </IForm>
  </div>
</template>
<script>
import {_editAccountPassword} from "@/services/screeningConfig/accountPasswords";
export default {
  name: "AccountPasswordEdit",
  data() {
    return {
      edit: {
        name: "",
        account: "",
        password: "",
        tcmAccount: "",
        tcmPassword: "",
        url: "",
        localAreaUrl: "",
        urlType: 1,
        printLog: 1,
        status:1
      },
      init: "",
      urlTypeList:[
        {label: '局域网', value: 1},
        {label: '映射', value: 2},
      ],
      printLogList:[
        {label: '不打印', value: 1},
        {label: '打印', value: 2},
      ],
      statusList:[
        {label: '启用', value: 1},
        {label: '停用', value: 2},
      ],
      accountPasswordElem: [],
      accountPasswordRule: {
        name: [
          {
            required: true,
            trigger: "blur",
            message: "名称不能为空"
          }
        ],
        account: [
          {
            required: true,
            trigger: "blur",
            message: "体检账号不能为空"
          }
        ],
        password: [
          {
            required: true,
            trigger: "blur",
            message: "体检密码不能为空"
          }
        ],
        localAreaUrl: [
          {
            required: true,
            trigger: "blur",
            message: "局域网路径不能为空"
          }
        ],
        status: [
          {
            required: true,
            trigger: "blur",
            message: "状态不能为空",
            type:'number'
          }
        ],
      },
    };
  },
  mounted() {
    this.init = Object.assign({}, this.edit);
  },
  methods: {
    handleModal(row) {
      this.$refs["formInline"].handleReset();
      if (!row) {
        this.handleCreate();
      } else {
        this.handleEdit(row);
      }
    },
    handleCreate() {
      this.edit = Object.assign({}, this.init);
    },
    handleEdit(row) {
      const edit = Object.assign({}, row);
      this.edit = {...edit};
      this.edit.label += "";
    },
    handleSubmit() {
      this.$refs["formInline"].handleSubmit('form');
    },
    toSubmit() {
      _editAccountPassword(this.edit)
        .then(res => {
          if (res.errcode == 1){
            this.$message.success("保存成功");
            this.$emit("on-submit", false);
          } else{
            this.$message.error(res.errmsg);
          }
        }).catch(() => {});
    },
  },
};
</script>
<style lang="postcss" scoped>

</style>
